import type { ComponentConfig } from "@puckeditor/core";
import { ComponentRef } from './component-ref';
import type { ComponentRefProps } from './component-ref';

/**
 * Puck configuration for ComponentRef
 *
 * This component allows referencing shared SiteComponents by their UUID,
 * enabling global navigation and footer that can be edited once and
 * reflected across all pages.
 */
const ComponentRefConfig: ComponentConfig<ComponentRefProps> = {
  defaultProps: {
    componentId: "",
    componentType: "navigation",
  },
  fields: {
    componentId: {
      label: "Component ID",
      type: "text",
    },
    componentType: {
      label: "Component Type",
      options: [
        { label: "Navigation", value: "navigation" },
        { label: "Footer", value: "footer" },
      ],
      type: "radio",
    },
  },
  label: "Component Reference",
  render: (props) => <ComponentRef {...props} />,
};

export { ComponentRefConfig };
